import { Condition } from '@staffino/model';
import { ConditionEvaluatorContext } from '../condition-evaluator-context';

export default async function structure(
  condition: Condition,
  context: ConditionEvaluatorContext,
): Promise<boolean> {
  const { operator, value } = condition[1];
  const targetId =
    context.stateManager.getTargetId() || context.bridge.targetId;
  if (targetId) {
    const [targetLineageObject] = await context.bridge.load({
      objectType: 'target-lineage',
      id: targetId,
    });
    if (targetLineageObject?.objectType === 'target-lineage') {
      const targetLineage = targetLineageObject.targets;
      const targetLineageIds = targetLineage?.map(
        (lineageItem) => lineageItem.id,
      );
      if (targetLineageIds?.length) {
        if (operator === 'contains') {
          return !!targetLineageIds.some((id) => value.includes(id));
        }
        if (operator === '!contains') {
          return !targetLineageIds.some((id) => value.includes(id));
        }
      }
    }
  }
  return false;
}
